import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/persistantProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/QueryclientProvider.tsx");
